import Image from 'next/image';
import {cn} from '@/lib/utils';
import {avertaSemibold} from '@/styles/fonts';
import {avertaLightItalic} from '@/styles/fonts';

type Props = {
  userReview: {
    text: string;
    user: string;
    stars: string[];
  };
};

export default function AboutUsReviewsCarouselCard({userReview}: Props) {
  const {stars, user, text} = userReview;
  return (
    <div className="px-[15%] desktop:px-[7%]">
      <blockquote
        className={cn(
          'text-xl italic leading-[1.45] mb-4 text-graphite font-normal',
          avertaLightItalic.className,
        )}>
        {text}
      </blockquote>
      <div className="mt-5 text-lg font-semibold">
        <div className="flex flex-row flex-wrap gap-x-4 gap-y-2">
          <div className="flex">
            {stars.map((star, index) => (
              <Image
                src={`https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/stars/${star}.svg`}
                alt={star}
                width={18}
                height={18}
                key={index}
                className="mr-1"
              />
            ))}
          </div>

          <p>
            <strong
              className={cn(
                'whitespace-normal text-lg',
                avertaSemibold.className,
              )}>
              {user}
            </strong>
          </p>
        </div>
      </div>
    </div>
  );
}
